import styled from 'styled-components/native';

const SimpleView = styled.View``;

export default SimpleView;
